import React from "react";
import "./index.css";
import {InfoCard} from "../../layout/InfoCard";

export const WrongBrowser = () => {
  return (
    <div className="browser-notice-container">
      <InfoCard>
        <h2>Unsupported Browser</h2>
        <p>
          It looks like you're trying to view CoverBaker in a browser that doesn't support some of
          its core features.
        </p>
        <p>
          To enjoy the full experience, please use{" "}
          <a href="https://www.google.com/chrome/" target="_blank">
            Google Chrome
          </a>{" "}
          or&nbsp;another Chromium&#8209;based browser like{" "}
          <a href="https://www.microsoft.com/en-us/edge" target="_blank">
            Microsoft Edge
          </a>
          ,{" "}
          <a href="https://brave.com/" target="_blank">
            Brave
          </a>
          ,{" "}
          <a href="https://www.opera.com/" target="_blank">
            Opera
          </a>
          .
        </p>
        <p className="text">Thanks for your understanding 🙏</p>
      </InfoCard>
    </div>
  );
};
